"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Landscaper = void 0;
const IAward_1 = require("../IAward");
class Landscaper {
    constructor() {
        this.name = 'Landscaper';
        this.description = 'Have the largest group of connected tiles';
    }
    getScore(player) {
        const board = player.game.board;
        const visited = new Set();
        let largestGroupSize = 0;
        const playerOwnedSpaces = board.spaces.filter((space) => space.player === player && space.tile !== undefined);
        for (const space of playerOwnedSpaces) {
            if (!visited.has(space)) {
                const groupSize = this.dfs(space, player, visited);
                largestGroupSize = Math.max(largestGroupSize, groupSize);
            }
        }
        return largestGroupSize + IAward_1.getAdditionalScore(player);
    }
    dfs(space, player, visited) {
        const stack = [space];
        let groupSize = 0;
        while (stack.length > 0) {
            const current = stack.pop();
            if (!current || visited.has(current))
                continue;
            visited.add(current);
            groupSize++;
            const adjacentSpaces = player.game.board.getAdjacentSpaces(current);
            for (const adj of adjacentSpaces) {
                if (adj.player === player && !visited.has(adj)) {
                    stack.push(adj);
                }
            }
        }
        return groupSize;
    }
}
exports.Landscaper = Landscaper;
//# sourceMappingURL=Landscaper.js.map